import Login from "./SignInUp/Login";
import { Route, Switch } from "react-router-dom";
import "./GlobalStyle.scss";
import Register from "./SignInUp/Register";
import MainPage from "./Dashboard/MainPage";
import CertificateDetails from "./Dashboard/CertificateDetails";
import CertificateType from "./Dashboard/AdminDashboard/CertificateType";
import ForgotPass from "./ForgotPassword/ForgotPass";
import About from "./Dashboard/About";
import LeadPage from "./Dashboard/AddLead/LeadPage";
import TemplatePage from "./Dashboard/AddCertificateTemplate/TemplatePage";
import AddTemplatePage from "./Dashboard/AddCertificateTemplate/addTemplateView/AddTemplatePage";
import LeadTemp from "./Dashboard/LeadTemp";

export const baseUrl = process.env.REACT_APP__KEY;
export const mainBaseUrl = process.env.REACT_APP__URL;

function App() {
  return (
    <div className="App">
      <Switch>
        <Route path="/" exact>
          <Login />
        </Route>
        <Route path="/register" exact>
          <Register />
        </Route>
        <Route path="/dashboard" exact>
          <MainPage />
        </Route>
        <Route path="/certificateDetails" exact>
          <CertificateDetails />
        </Route>
        <Route path="/certificateType" exact>
          <CertificateType />
        </Route>
        <Route path="/forgotPass" exact>
          <ForgotPass />
        </Route>
        <Route path="/about" exact>
          <About />
        </Route>
        <Route path="/lead" exact>
          <LeadPage />
        </Route>
        <Route path="/certificateTemplate" exact>
          <TemplatePage />
        </Route>
        <Route path="/addTemplate" exact>
          <AddTemplatePage />
        </Route>
        <Route path="/leadTemp" exact>
          <LeadTemp />
        </Route>
      </Switch>
    </div>
  );
}

export default App;
